"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var TYPES = ['Spacer01', 'Spacer02', 'Spacer03', 'Spacer04', 'Spacer05', 'Spacer06'];

var Spacer = function Spacer(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.getClassName('spacer')
  }, /*#__PURE__*/React.createElement("span", {
    className: TYPES.find(function (type) {
      return type === props.type;
    })
  }));
};

Spacer.displayName = displayNames.Spacer;
Spacer.propTypes = {
  type: PropTypes.string.isRequired
};
module.exports = compose(Spacer);